import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";

import Icon from "../../icon";

class DateRange extends Component {
    constructor(props) {
        super(props);
        this.state = {
          startDate: null,
          endDate: null,
        };
      }

      datePickerOnChange = (dates) => {
          const { dateOnly, onChange } = this.props;
          const [start, end] = dates;

          const startDt = dateOnly && start ? new Date(`${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`) : start;
          const endDt = dateOnly && end ? new Date(`${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`) : end;
          this.setState({endDate:endDt,startDate:startDt})
          onChange([startDt, endDt]);
      }

      handleInputField=(e)=>{
        const inputValue = e.target.value;
        if (inputValue === "") {
            this.props.onChange([null, null]);
        }
      }

      handleBlur = () => {
        const { startDate, endDate } = this.state;       
        if (startDate && !endDate) {
          this.props.onChange([startDate, startDate]);
        }
      }

      render() {
      
        const {startDate, endDate, label, onChange, placeholder, requiredField, dateRangeWrapperClass} = this.props
        const { activeDateFormat } = this.props.adminSetting;

        const CustomInput = React.forwardRef(({ value, onClick, onChange, onBlur }, ref) => (
          <input type="text" className="form-control" value={value} placeholder={placeholder} onClick={onClick} ref={ref} onChange={onChange} />
        ));
        return (
            <div className={`date-picker-container ${dateRangeWrapperClass} ${requiredField ? "required":""} date-range-container`}>    
            <div className="custom-input-label">{label}</div>    
                <DatePicker
                    selectsRange={[startDate, endDate]}
                    startDate={startDate}             
                    endDate={endDate}
                    onChange={this.datePickerOnChange}
                    onCalendarClose={this.handleBlur}
                    placeholderText={label}
                    dateFormat={activeDateFormat.CSFormat}
                    customInput={<CustomInput onChange={this.handleInputField} />}
                />
                 <Icon
                    customClassName="icon-left"
                    name="calendar-days"      
                    size="25px"
                    containerClass="calendar-icon"
                />
            </div>
        );
      }
}

export default connect(
    state => {
        const { adminSetting } = state;

        return {
            adminSetting
        };
    }
)(DateRange)